// Text filter for a long list or table in rich content. An element `<div data-rem-filter="#list tbody tr"
// data-rem-filter-placeholder="Search">` becomes a search input; typing hides the rows (elements matching the CSS
// selector) whose text does not contain the typed words, ignoring case and accents. Without a script the div stays
// empty and every row stays visible.

// Lower case without diacritics, so "ő" is found by "o".
export const normalize = (text) => String(text).normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();

// Every typed word has to occur in the text of the row.
export const matches = (haystack, query) => normalize(query).split(/\s+/).filter(Boolean).every((word) => haystack.includes(word));

// `texts` caches the normalized text of the rows, so typing in a 400 row table normalizes each row only once.
export const filterRows = (rows, query, texts = new WeakMap()) => {
    rows.forEach((row) => {
        if (!texts.has(row)) {
            texts.set(row, normalize(row.textContent));
        }
        row.hidden = !matches(texts.get(row), query);
    });
};

export const initFilters = (root) => {
    root.querySelectorAll('[data-rem-filter]').forEach((holder) => {
        if (holder.dataset.remFilterBound === '1') {
            return;
        }
        holder.dataset.remFilterBound = '1';
        const selector = holder.dataset.remFilter;
        const placeholder = holder.dataset.remFilterPlaceholder || '';
        const input = document.createElement('input');
        input.type = 'search';
        input.className = 'rem-filter__input';
        input.placeholder = placeholder;
        input.setAttribute('aria-label', placeholder || 'Filter');
        const texts = new WeakMap();
        input.addEventListener('input', () => {
            try {
                filterRows(Array.from(document.querySelectorAll(selector)), input.value, texts);
            } catch (error) {
                // an invalid selector filters nothing
            }
        });
        holder.append(input);
    });
};
